export enum FinanceTransactionType {
  Payment = 1,
  Refund = 2,
  Cancellation = 4,
  Void = 5,
}
